
































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mask } from "vue-the-mask";
import { Document } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
@Component({ directives: { mask } })
export default class PersonDocument extends Vue {
    @Prop() passport: Document;
    @Prop() birthDate: Date;
    Rules = ValidationRules;

    get seriesNumberInputText(): string {
        if (!this.passport.seria && !this.passport.number) return "";
        return this.passport.seria + " " + this.passport.number;
    }
    set seriesNumberInputText(val) {
        this.passport.seria = val.substring(0, 4);
        this.passport.number = val.substring(5);
    }
}
